/**
 *
 * https://github.com/diffusion-fi/v2-periphery/blob/main/scripts/config/config.ts
 *
 * When changing this also update: cypress/integration/contracts.ts
 *
 */

const PERIPHERY_TESTNET = {
  factory: '0x0000000000000000000000000000000000000000',
  weth9: '0x0000000000000000000000000000000000000000',
  router: '0x0000000000000000000000000000000000000000',
  mockUSDC: '0x0000000000000000000000000000000000000000',
  mockCANTO: '0x0000000000000000000000000000000000000000',
  mockATOM: '0x0000000000000000000000000000000000000000',
  mockOSMOSIS: '0x0000000000000000000000000000000000000000',
  multicall2: '0x0000000000000000000000000000000000000000',
  LHS: '0x0000000000000000000000000000000000000000',
  RHS: '0x0000000000000000000000000000000000000000',
  testerAddress: '0x0000000000000000000000000000000000000000',
  //0x851e5cE9fa409B731f980a5E00FA889b58D9037D
  // 0xA2c659531B15bFf2556Ea7E12D477D3C8761ACD9
  //0x95BF964f113a75a3974E8164105e6e5A8D743b87
  // 0x62154D72C202f04CA50a3Ba5630052D0348f337A
  rewardToken: '0x0000000000000000000000000000000000000000',
  secondaryRewardToken: '0x0000000000000000000000000000000000000000',
  miniChef: '0x0000000000000000000000000000000000000000',
  complexRewarderTime: '0x0000000000000000000000000000000000000000',
  diffusion: '0x0000000000000000000000000000000000000000',
}

const MAINNET_PERIPHERY = {
  factory: '0xa2899c776bAAF9925d432F83C950D5054A6CF59C',
  weth9: '0x4F9A0e7FD2Bf6067db6994CF12E4495Df938E6e9',
  router: '0xd3Ea3BC1F5A3F881bD6cE9761cbA5A0833a5d737',
  multicall2: '0x554f16d513e1eB2fDf3b8CaAAb50405415Fa405A',
  //
  minichef: '0x0000000000000000000000000000000000000000',
  diffusion: '0x7Be3B0658C30De4896F89D26f79D6D64DDa7ea8e',
}

export const MAINNET = {
  ...MAINNET_PERIPHERY,
  diffusionbar: '0x0000000000000000000000000000000000000000',
  airdrop: '0x0000000000000000000000000000000000000000',
}

export const TESTNET = {
  ...PERIPHERY_TESTNET,
  airdrop: '0x0000000000000000000000000000000000000000',
  diffusionbar: '0x0000000000000000000000000000000000000000',
}
